/* VaultRx Precision — global.js */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function closeSearch(bar) {
    bar.classList.remove('is-open');
    bar.classList.add('is-closing');
    setTimeout(function () {
      bar.classList.remove('is-closing');
      bar.hidden = true;
    }, 230);
  }

  /* ---------- Mobile nav toggle ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    /* Search bar toggle */
    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var bar = document.querySelector('[data-search-bar]');
      if (bar) {
        if (bar.classList.contains('is-open')) {
          closeSearch(bar);
        } else if (!bar.classList.contains('is-closing')) {
          bar.hidden = false;
          bar.classList.add('is-open');
          var input = bar.querySelector('input[type="search"], input[name="q"]');
          if (input) input.focus();
        }
      }
    }

    /* Close open desktop dropdowns when clicking outside */
    document.querySelectorAll('.site-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.site-nav details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      var bar = document.querySelector('[data-search-bar]');
      if (bar && bar.classList.contains('is-open')) {
        closeSearch(bar);
      }
    }
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10) || min;
    val = Math.max(min, val + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: update lines via AJAX when quantity changes */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    var input = e.target;
    var form = input.closest('form');
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (!line) { if (form) form.submit(); return; }
    var row = input.closest('tr');
    if (row) row.classList.add('is-updating');
    if (form) form.classList.add('cart-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function (cart) {
        if (qty === 0 || !cart.items[line - 1]) { window.location.reload(); return; }
        var format = (form && form.getAttribute('data-money-format')) || '${{amount}}';
        var totalEl = row && row.querySelector('[data-line-total]');
        if (totalEl) totalEl.textContent = formatMoney(cart.items[line - 1].final_line_price, format);
        var subEl = document.querySelector('[data-cart-subtotal]');
        if (subEl) subEl.textContent = formatMoney(cart.total_price, format);
        setCartCount(cart.item_count);
        if (row) row.classList.remove('is-updating');
        if (form) form.classList.remove('cart-updating');
      })
      .catch(function () { if (form) form.submit(); });
  });

  /* ---------- Product variant picker ----------
     Expects:
     - <form data-product-form> with hidden input[name="id"]
     - <script type="application/json" data-product-json> with product JSON
     - radios named "option-{position}" OR selects with data-option-position
     - [data-price-wrapper], [data-add-button], [data-add-button-text]
  */
  function initProductForm(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceWrap = root.querySelector('[data-price-wrapper]');
    var addBtn = root.querySelector('[data-add-button]');
    var addBtnText = root.querySelector('[data-add-button-text]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (opt, i) {
        var pos = i + 1;
        var checked = root.querySelector('input[name="option-' + pos + '"]:checked');
        if (checked) { opts[i] = checked.value; return; }
        var sel = root.querySelector('select[data-option-position="' + pos + '"]');
        if (sel) { opts[i] = sel.value; }
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addBtnText) { addBtnText.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;

      if (priceWrap) {
        var html = '<span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s class="price__compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
          priceWrap.classList.add('price--on-sale');
        } else {
          priceWrap.classList.remove('price--on-sale');
        }
        priceWrap.innerHTML = html;
      }

      if (addBtn && addBtnText) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtnText.textContent = addBtn.getAttribute('data-add-label') || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtnText.textContent = 'Sold out';
        }
      }

      /* Swap featured image if the variant has one */
      if (variant.featured_image) {
        var mainImg = document.querySelector('[data-gallery-main] img');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.removeAttribute('srcset');
        }
      }

      /* Keep URL in sync */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[name^="option-"], select[data-option-position]')) update();
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-gallery-main] img');
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    if (thumb.getAttribute('data-srcset')) {
      main.srcset = thumb.getAttribute('data-srcset');
    } else {
      main.removeAttribute('srcset');
    }
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---------- Quick add (product cards) ---------- */
  function bumpCartCount(delta) {
    var icon = document.querySelector('[data-cart-icon]');
    if (!icon) return;
    var count = icon.querySelector('[data-cart-count]');
    if (!count) {
      count = document.createElement('span');
      count.className = 'cart-count';
      count.setAttribute('data-cart-count', '');
      count.textContent = '0';
      icon.appendChild(count);
    }
    var n = parseInt(count.textContent, 10) || 0;
    count.textContent = n + delta;
    count.classList.remove('bump');
    void count.offsetWidth;
    count.classList.add('bump');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-quick-add-btn]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added'; btn.classList.add('is-added'); }
        if (getDrawer()) { refreshDrawer(true); } else { bumpCartCount(1); }
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; btn.classList.remove('is-added'); }
        }, 1500);
      })
      .catch(function () {
        var link = form.getAttribute('data-product-url');
        if (link) { window.location.href = link; }
        else if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- Scroll-in reveals ---------- */
  function initReveals() {
    if (document.body.classList.contains('no-animations')) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var selector = '.section-header, .card, .collection-tile, .feature-col, .testimonial, .hero__content > *, .image-text > *';
    var groups = {};
    var els = document.querySelectorAll(selector);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        return; /* already in view on load — don't hide it */
      }
      var parent = el.parentElement;
      var key = parent ? Array.prototype.indexOf.call(document.querySelectorAll('*'), parent) : 0;
      groups[key] = (groups[key] || 0) + 1;
      el.style.setProperty('--reveal-i', (groups[key] - 1) % 6);
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  /* ---------- Cart drawer ---------- */
  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function setCartCount(n) {
    var icon = document.querySelector('[data-cart-icon]');
    if (!icon) return;
    var count = icon.querySelector('[data-cart-count]');
    if (n > 0 && !count) {
      count = document.createElement('span');
      count.className = 'cart-count';
      count.setAttribute('data-cart-count', '');
      icon.appendChild(count);
    }
    if (count) {
      if (n > 0) {
        count.textContent = n;
        count.classList.remove('bump');
        void count.offsetWidth;
        count.classList.add('bump');
      } else {
        count.remove();
      }
    }
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('open'); });
    document.body.style.overflow = 'hidden';
    var closeBtn = d.querySelector('[data-cart-drawer-close]');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 300);
  }

  function refreshDrawer(open) {
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var current = getDrawer();
        if (fresh && current) {
          var wasOpen = current.classList.contains('open');
          current.replaceWith(fresh);
          if (wasOpen || open) {
            fresh.hidden = false;
            requestAnimationFrame(function () { fresh.classList.add('open'); });
            document.body.style.overflow = 'hidden';
          }
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          setCartCount(cart.item_count);
        });
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); return; }
    var qtyBtn = e.target.closest('[data-drawer-qty]');
    if (qtyBtn) {
      var input = qtyBtn.parentElement.querySelector('input');
      var q = (parseInt(input.value, 10) || 0) + (parseInt(qtyBtn.getAttribute('data-drawer-qty'), 10) || 0);
      changeDrawerLine(qtyBtn.getAttribute('data-line'), Math.max(0, q));
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-drawer-qty-input]')) {
      changeDrawerLine(e.target.getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = getDrawer();
      if (d && !d.hidden) closeDrawer();
    }
  });

  function changeDrawerLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function () { refreshDrawer(true); });
  }

  /* ---------- AJAX add to cart (product page forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-quick-add-form]')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!getDrawer()) return; /* drawer disabled — keep default redirect behavior */
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var label = form.querySelector('[data-add-button-text]');
    var original = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (label) label.textContent = original;
        if (btn) btn.disabled = false;
        refreshDrawer(true);
      })
      .catch(function () {
        if (label) label.textContent = original;
        if (btn) btn.disabled = false;
        form.submit();
      });
  });

  /* ---------- Share button ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-button]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    var label = btn.querySelector('[data-share-label]');
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        if (label) {
          label.textContent = 'Link copied';
          setTimeout(function () { label.textContent = 'Share'; }, 2000);
        }
      });
    }
  });

  /* ---------- Related products (Shopify recommendations) ---------- */
  function initRelatedProducts() {
    var el = document.querySelector('[data-related-products]');
    if (!el || !el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var fresh = tmp.querySelector('[data-related-products]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- Reorder (customer order page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reorder]');
    if (!btn) return;
    var payload = document.querySelector('[data-reorder-items]');
    if (!payload) return;
    var items;
    try { items = JSON.parse(payload.textContent); } catch (err) { return; }
    items = items.filter(function (i) { return i.id; }).map(function (i) {
      var out = { id: i.id, quantity: i.quantity || 1 };
      if (i.properties && Object.keys(i.properties).length) out.properties = i.properties;
      return out;
    });
    if (!items.length) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding to cart…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('reorder failed'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added — opening cart';
        setTimeout(function () { window.location.href = '/cart'; }, 500);
      })
      .catch(function () {
        btn.textContent = 'Some items are unavailable';
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2500);
      });
  });

  /* Public API for custom sections (e.g. the label order form) */
  window.VaultRxTheme = {
    openCartDrawer: function () { refreshDrawer(true); },
    formatMoney: formatMoney
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-form-wrapper]').forEach(initProductForm);
    initReveals();
    initRelatedProducts();
  });
})();
